angular.module('kareo.ui.shared.modules.data.models', ['kareo.ui.shared.modules.dataServices'])
.factory('PrivilegesFactory', [=>
  PrivilegesFactory = =>

  PrivilegesFactory.fromData = (data) ->
    privs = []
    for p in data
      if not privs[p.id] or
        privs[p.id].accessType < p.accessType
          privs[p.id] = p
    return privs

  PrivilegesFactory
])

.factory('TaskAlertsFactory', [=>
  TaskAlertsFactory = =>

  TaskAlertsFactory.fromData = (data) ->
    data

  TaskAlertsFactory
])


.factory('PatientFactory', ['k_modelTransformer', (k_modelTransformer) =>
  patientFactory = class Patient
    dob: =>
      moment(@dateOfBirth).utc()

  patientFactory.fromData = (obj) ->
    k_modelTransformer.transform(obj, patientFactory)

  patientFactory
])

.factory('UserFactory', ['k_modelTransformer', (k_modelTransformer) =>
  capitalizeFirstLetter = (text) ->
    (text or '').toLowerCase().replace /\b[a-z]/g, (letter) ->
      letter.toUpperCase()

  userFactory = class User
    fullName: => capitalizeFirstLetter(@firstName) + ' ' + capitalizeFirstLetter(@lastName)

  userFactory.fromData = (obj) ->
    obj?.roles = obj.roles || []
    k_modelTransformer.transform(obj, userFactory)

  userFactory
])
